// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2d93Z","itemTitle":"ClientEmergencyInfo_itemTitle__3kIHH","itemText":"ClientEmergencyInfo_itemText__3eR7D"};